import { render, staticRenderFns } from "./BarChart.vue?vue&type=template&id=6d8667de&scoped=true&"
import script from "./BarChart.vue?vue&type=script&lang=js&"
export * from "./BarChart.vue?vue&type=script&lang=js&"
import style0 from "./BarChart.vue?vue&type=style&index=0&id=6d8667de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8667de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d8667de')) {
      api.createRecord('6d8667de', component.options)
    } else {
      api.reload('6d8667de', component.options)
    }
    module.hot.accept("./BarChart.vue?vue&type=template&id=6d8667de&scoped=true&", function () {
      api.rerender('6d8667de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/chartjs/BarChart.vue"
export default component.exports